module.exports = __webpack_public_path__ + "img/gift-2.4645ac67.svg";